import { render, staticRenderFns } from "./row.vue?vue&type=template&id=27c34f3a&scoped=true&lang=pug"
import script from "./row.vue?vue&type=script&lang=js"
export * from "./row.vue?vue&type=script&lang=js"
import style0 from "./row.vue?vue&type=style&index=0&id=27c34f3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27c34f3a",
  null
  
)

export default component.exports